import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiInput from "components/VuiInput";
import VuiTypography from "components/VuiTypography";
import Globe from "examples/Globe";
import GradientBorder from "examples/GradientBorder";
import { IoCopy } from "react-icons/io5";
import { Card } from "@mui/material";
import { vars } from "services/constants";

export function AppWelcomeCard({ pageData, fullInfoIb }) {
  const calculateLeftDays = (endDate) => {
    const currentDate = new Date();
    const endIbDate = new Date(endDate);
    const seconds = 24 * 60 * 60 * 1000;
    return Math.ceil((endIbDate - currentDate) / seconds);
  };

  const handleCopyLink = (type) => {
    switch (type) {
      case "standardRegisterUrl":
        navigator.clipboard.writeText(fullInfoIb?.partnerRegisterUrl);
        break;
      case "directPurchaseRegisterUrl":
        navigator.clipboard.writeText(fullInfoIb?.partnerDirectPurchaseRegisterUrl);
        break;
      default:
        break;
    }
  };
  return (
    <Card
      sx={({ breakpoints }) => ({
        padding: "36px 20px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        [breakpoints.down("md")]: {
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
      })}
    >
      <VuiBox
        sx={({ breakpoints }) => ({
          maxWidth: "70%",
          [breakpoints.down("md")]: {
            maxWidth: "100%",
          },
        })}
      >
        <VuiBox>
          <VuiTypography
            sx={{
              fontSize: "32px",
              fontWeight: "700",
              lineHeight: "32px",
              color: "#FFFFFF",
            }}
          >
            {pageData.welcomeMessage(fullInfoIb?.firstName ?? "")}
          </VuiTypography>
          <VuiBox
            component="p"
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              color: "#FFFFFF",
              marginTop: "10px",
              marginBottom: "16px",
            }}
          >
            {pageData.shareMessage}
          </VuiBox>
        </VuiBox>
        {fullInfoIb && fullInfoIb.ibCycleEnd && !fullInfoIb.isIPF && (
          <VuiBox
            sx={{
              display: "block",
              padding: "9px 13px",
              width: "fit-content",
              borderRadius: "5px",
              backgroundColor: "#062B63BF",
              color: "#FFFFFF",
              fontSize: "14px",
              fontWeight: "700",
              marginBottom: "16px",
            }}
          >
            {pageData.daysLeft(calculateLeftDays(fullInfoIb.ibCycleEnd))}
          </VuiBox>
        )}
        <VuiBox sx={{ display: "flex", flexDirection: "column" }}>
          <VuiTypography
            sx={{
              fontSize: "14px",
              fontWeight: "700",
              lineHeight: "32px",
              color: "#FFFFFF",
            }}
          >
            Link Registro Estándar
          </VuiTypography>
          <VuiBox sx={{ display: "flex", flexDirection: "row" }}>
            <GradientBorder
              borderRadius="20px"
              sx={({ breakpoints }) => ({
                width: "100%",
                marginBottom: "16px",
                [breakpoints.down("md")]: {
                  width: "100%",
                },
              })}
            >
              <VuiInput
                sx={{
                  padding: "10px",
                  width: "100%",
                }}
                readOnly={true}
                value={fullInfoIb?.partnerRegisterUrl ?? ""}
              />
            </GradientBorder>
            <VuiBox>
              <VuiButton
                onClick={() => handleCopyLink("standardRegisterUrl")}
                color="info"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "5px",
                }}
              >
                <IoCopy />
                <VuiTypography
                  color="white"
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                    lineHeight: "21px",
                  }}
                >
                  COPIAR
                </VuiTypography>
              </VuiButton>
            </VuiBox>
          </VuiBox>
        </VuiBox>
        {
          vars.directPurchase.enabled && (
            <VuiBox sx={{ display: "flex", flexDirection: "column" }}>
          <VuiTypography
            sx={{
              fontSize: "14px",
              fontWeight: "700",
              lineHeight: "32px",
              color: "#FFFFFF",
            }}
          >
            Link Registro Compra Directa
          </VuiTypography>
          <VuiBox sx={{ display: "flex", flexDirection: "row" }}>
            <GradientBorder
              borderRadius="20px"
              sx={({ breakpoints }) => ({
                width: "100%",
                marginBottom: "16px",
                [breakpoints.down("md")]: {
                  width: "100%",
                },
              })}
            >
              <VuiInput
                sx={{
                  padding: "10px",
                  width: "100%",
                }}
                readOnly={true}
                value={fullInfoIb?.partnerDirectPurchaseRegisterUrl ?? ""}
              />
            </GradientBorder>
            <VuiBox>
              <VuiButton
                onClick={() => handleCopyLink("directPurchaseRegisterUrl")}
                color="info"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "5px",
                }}
              >
                <IoCopy />
                <VuiTypography
                  color="white"
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                    lineHeight: "21px",
                  }}
                >
                  COPIAR
                </VuiTypography>
              </VuiButton>
            </VuiBox>
          </VuiBox>
        </VuiBox>
          )
        }
      </VuiBox>

      <VuiBox
        sx={({ breakpoints }) => ({
          maxWidth: "30%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          [breakpoints.down("md")]: {
            maxWidth: "100%",
            marginTop: "20px",
          },
        })}
      >
        <Globe canvasStyle={{ width: "100%", height: "100%" }} />
      </VuiBox>
    </Card>
  );
}
